
export function DashboardSection() {
  return (
    <section className="py-24 bg-gradient-to-b from-black to-gray-900">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
              Simple Dashboard, Powerful Insights
            </h2>
            <p className="text-xl text-gray-400">
              Get a complete picture of your security status in 60 seconds
            </p>
          </div>

          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <img
                src="https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=600&h=500&fit=crop&crop=center"
                alt="Driscop security dashboard"
                className="w-full h-auto rounded-xl shadow-lg object-cover"
              />
            </div>
            
            <div>
              <div className="space-y-8">
                <div>
                  <h3 className="text-xl font-semibold text-white mb-3">
                    <i className="ri-shield-check-line text-blue-400 mr-2"></i>
                    Threat Detection Overview
                  </h3>
                  <p className="text-gray-400 leading-relaxed">
                    See all detected phishing and smishing attempts in real-time, with detailed analysis of threat types and sources.
                  </p>
                </div>
                
                <div>
                  <h3 className="text-xl font-semibold text-white mb-3">
                    <i className="ri-team-line text-blue-400 mr-2"></i>
                    Employee Risk Scores
                  </h3>
                  <p className="text-gray-400 leading-relaxed">
                    Track individual and team security awareness levels, identifying who needs additional support or training.
                  </p>
                </div>
                
                <div>
                  <h3 className="text-xl font-semibold text-white mb-3">
                    <i className="ri-lightbulb-line text-blue-400 mr-2"></i>
                    Actionable Recommendations
                  </h3>
                  <p className="text-gray-400 leading-relaxed">
                    Receive specific, prioritized recommendations to improve your cybersecurity posture based on detected patterns.
                  </p>
                </div>
                
                <div>
                  <h3 className="text-xl font-semibold text-white mb-3">
                    <i className="ri-file-chart-line text-blue-400 mr-2"></i>
                    Compliance Reporting
                  </h3>
                  <p className="text-gray-400 leading-relaxed">
                    Generate reports for insurance, audits, or compliance requirements with just one click.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
